import { Component, Input } from '@angular/core';
import { AbstractControl, FormControl } from '@angular/forms';

@Component({
	selector: 'app-subscribe-to-mailing-checkbox',
	templateUrl: './subscribe-to-mailing-checkbox.component.html',
	styleUrl: './subscribe-to-mailing-checkbox.component.scss',
})
export class SubscribeToMailingCheckboxComponent {
	@Input() control: AbstractControl;
	@Input() variant: 'checkbox' | 'toggle' = 'checkbox';

	get isToggleVariant() {
		return this.variant === 'toggle';
	}

	get formControl() {
		return this.control as FormControl;
	}

	handleControlChange(event: CustomEvent<{ checked: boolean }>) {
		this.formControl.setValue(event.detail.checked);
	}
}
